export function trackQuizEvent(eventName, detail = {}) {
  if (typeof window === 'undefined') return;

  if (Array.isArray(window.dataLayer)) {
    window.dataLayer.push({ event: eventName, ...detail });
  }

  window.dispatchEvent(
    new CustomEvent('niegewoon:analytics', {
      detail: { event: eventName, ...detail }
    })
  );
}